/* eslint-disable */
export default {
  cancel: 'Abbrechen',
  pmiChangeConfirmed: 'Ändern',
  pmiChangeConfirmTitle: 'Einstellungen für persönliche Besprechung ändern?',
  pmiChangeConfirmContext:
    'Änderungen an diesen Einstellungen betreffen alle Besprechungen, die Ihre persönliche Besprechungs-ID oder Ihren persönlichen Besprechungsnamen verwenden. Dies betrifft auch bereits geplante Besprechungen.',
  updatePassword: 'Kennwort aktualisieren',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
